"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/casting/Metal-Casting/advantages-of-metal-casting.webp";

const ITEMS = [
	{ titleKey: "advantagesItem1Title", descKey: "advantagesItem1Desc" },
	{ titleKey: "advantagesItem2Title", descKey: "advantagesItem2Desc" },
	{ titleKey: "advantagesItem3Title", descKey: "advantagesItem3Desc" },
] as const;

const CheckCircleIcon = () => (
	<svg className="mt-1 h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="8" fill="#78b63f" />
		<path
			d="M6.4 10.2L8.7 12.4L13.6 7.6"
			stroke="white"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function MetalCastingAdvantages() {
	const t = useTranslations("new-metal-casting");

	return (
		<section className="pt-8 sm:pt-10 md:pt-12 lg:pt-16">
			<div className="container">
				<div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-10 xl:gap-14">
					<div className="relative aspect-[23/21] w-full overflow-hidden bg-gray-100">
						<Image
							src={encodeURI(IMAGE_SRC)}
							alt={t("advantagesImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 52vw"
						/>
					</div>

					<div>
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("advantagesTitle")}
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:text-base">
							{t("advantagesDesc")}
						</p>
						<div className="space-y-5">
							{ITEMS.map((item) => (
								<div key={item.titleKey}>
									<p className="mb-2 flex items-start gap-3">
										<CheckCircleIcon />
										<span className="text-base font-semibold leading-tight text-black sm:text-lg">
											{t(item.titleKey)}
										</span>
									</p>
									<p className="pl-8 text-sm leading-relaxed text-black md:text-base">{t(item.descKey)}</p>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
